const MicrophoneBarExpandIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 24 24"
  >
    <path
      d="M4 7.5a.5.5 0 0 1-1 0v-2A2.5 2.5 0 0 1 5.5 3h2a.5.5 0 0 1 0 1h-2A1.5 1.5 0 0 0 4 5.5zM16.5 4a.5.5 0 1 1 0-1h2A2.5 2.5 0 0 1 21 5.5v2a.5.5 0 1 1-1 0v-2A1.5 1.5 0 0 0 18.5 4zM20 16.5a.5.5 0 1 1 1 0v2a2.5 2.5 0 0 1-2.5 2.5h-2a.5.5 0 1 1 0-1h2a1.5 1.5 0 0 0 1.5-1.5zM7.5 20a.5.5 0 1 1 0 1h-2A2.5 2.5 0 0 1 3 18.5v-2a.5.5 0 1 1 1 0v2A1.5 1.5 0 0 0 5.5 20z"
      fill="white"
    ></path>
  </svg>
);

export default MicrophoneBarExpandIcon;
